import { differenceInMinutes } from 'date-fns';
import parseDate from './parseDate';

const getDateDifferenceInMinutes = (date1, date2) => {
  const parsedDateTime1 = parseDate(date1);
  const parsedDateTime2 = parseDate(date2);

  return parsedDateTime1 && parsedDateTime2 ? differenceInMinutes(parsedDateTime1, parsedDateTime2) : null;
};

export default getDateDifferenceInMinutes;
